export default __webpack_public_path__ + "assets/products/product-mealkit.eb63dc365f2261509060b67076ac3af6.webp";